import {flow} from 'lodash';
import * as React from 'react';
import {connect} from 'react-redux';
import { Button } from 'react-bootstrap';
import {bindActionCreators} from 'redux';
import {toastr} from 'react-redux-toastr';
import {IStore} from '../../redux/IStore';
import { FaSpinner } from 'react-icons/fa';
import {ITraveller} from '../../data/api/models';
import AddPaymentCardModal from './components/AddPaymentCardModal';
import {paymentMethodActions} from '../../services/paymentMethod/actions';
import {IPaymentMethodActions} from '../../services/paymentMethod/models';
import AddPaymentCardTransactionModal from './components/AddPaymentCardTransactionModal';

interface IAddPaymentCardProps {
  buttonTitle: string;
  buttonDisabled: boolean;
  showSpinner: boolean;
  travellers: ITraveller[];
  customerId: string;
  policyId: string;
  classStyle?: string;
  isBlock?: boolean;
  actions: {
    paymentMethod: IPaymentMethodActions;
  }
}

interface IAddPaymentCardState {
  hasError: boolean;
  showCardModal: boolean;
  showCardTransactionModal: boolean;
  transactionId: string;
}

class AddPaymentCard extends React.Component<IAddPaymentCardProps, IAddPaymentCardState> {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      showCardModal: false,
      showCardTransactionModal: false,
      transactionId: '',
    };
  }

  private openCardModal = () => {
    this.setState({
      showCardModal: true,
    });
  }

  private closeCardModal = () => {
    this.setState({
      showCardModal: false,
    });
  }

  private openCardTransactionModal = (transactionId: string) => {
    this.setState({
      showCardTransactionModal: true,
      transactionId,
    });
  }

  private closeCardTransactionModal = () => {
    this.setState({
      showCardTransactionModal: false,
    });
  }

  private assignCardToPolicy = (policyId: string, customerPaymentMethodId: string) => {
    const { customerId, actions } = this.props;
    actions.paymentMethod.assignCardToPolicy(customerId, policyId, customerPaymentMethodId, (success) => {
      if (success) {
        toastr.success('Card assigned successfully');
      } else {
        toastr.error('Failed to assign card')
      }
    });
  }

  public render() {
    const {
      buttonTitle,
      buttonDisabled,
      showSpinner,
      travellers,
      customerId,
      policyId,
      classStyle,
      isBlock = false,
    } = this.props;

    return (
      <>
        <Button
          bsStyle={'primary'}
          className={classStyle ? classStyle : 'medium-width secondary-button'}
          onClick={this.openCardModal}
          block={isBlock}
          disabled={buttonDisabled}>
          {showSpinner && (<FaSpinner className="fa-spin"/>)}{buttonTitle}
        </Button>

        <AddPaymentCardModal
          show={this.state.showCardModal}
          closeModal={this.closeCardModal}
          openCardTransactionModal={this.openCardTransactionModal}
          permissions={true}
          leadTraveller={travellers[0]}
          isMta={false}
          travellers={travellers}
          customerId={customerId}
          policyId={policyId}
        />

        <AddPaymentCardTransactionModal
          show={this.state.showCardTransactionModal}
          closeModal={this.closeCardTransactionModal}
          transactionId={this.state.transactionId}
          policyId={policyId}
          assignCardToPolicy={this.assignCardToPolicy}
        />
      </>
    );
  }
}

export default flow([
  connect(
    (state: IStore) => {
      return {};
    },
    (dispatch) => ({
      actions: {
        dispatch,
        paymentMethod: bindActionCreators({ ...paymentMethodActions }, dispatch),
      }
    })
  )
])(AddPaymentCard);
